import { ExternalLink, Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { STORES } from "../data/site";

const StoreCard = ({ store, delay }) => (
  <Reveal delay={delay} className={store.primary ? "lg:col-span-3" : ""}>
    <a
      href={store.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`store-card-${store.id}`}
      className={`group relative flex h-full flex-col overflow-hidden rounded-2xl border p-6 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 sm:p-7 ${
        store.primary
          ? "border-amber-500/40 bg-gradient-to-br from-amber-500/[0.08] via-[#12141A] to-[#12141A] shadow-[0_0_45px_rgba(212,175,55,0.12)] hover:border-amber-400/70 hover:shadow-[0_0_65px_rgba(212,175,55,0.22)] lg:flex-row lg:items-center lg:justify-between lg:gap-10 lg:p-10"
          : "border-zinc-800 bg-[#12141A] hover:border-amber-500/40 hover:shadow-[0_0_35px_rgba(212,175,55,0.12)]"
      }`}
    >
      {store.primary && (
        <div
          aria-hidden="true"
          className="absolute -right-20 -top-20 h-56 w-56 rounded-full bg-amber-500/10 blur-3xl"
        />
      )}
      <div className="relative">
        <span
          data-testid={`store-badge-${store.id}`}
          className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] ${
            store.primary
              ? "bg-amber-400 text-zinc-950"
              : "border border-zinc-700 text-zinc-400"
          }`}
        >
          {store.primary && <Star className="h-3 w-3 fill-current" aria-hidden="true" />}
          {store.badge}
        </span>
        <h3
          className={`mt-4 font-display font-bold text-white ${
            store.primary ? "text-3xl sm:text-4xl" : "text-2xl"
          }`}
        >
          {store.name}
        </h3>
        <p className={`mt-3 leading-relaxed text-zinc-400 ${store.primary ? "max-w-xl text-base" : "text-sm"}`}>
          {store.description}
        </p>
        <p className="mt-4 font-mono text-xs text-zinc-500" data-testid={`store-handle-${store.id}`}>
          {store.handle}
        </p>
      </div>
      <span
        data-testid={`store-cta-${store.id}`}
        className={`relative mt-6 shrink-0 lg:mt-0 ${
          store.primary
            ? "gold-btn px-8 py-4 text-sm"
            : "inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-amber-300 transition-colors group-hover:text-amber-200"
        }`}
      >
        {store.cta}
        <ExternalLink
          className={`h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 ${
            store.primary ? "" : "text-amber-400"
          }`}
          aria-hidden="true"
        />
      </span>
    </a>
  </Reveal>
);

export const Marketplaces = () => (
  <section
    id="shop"
    data-testid="shop-section"
    className="relative scroll-mt-20 border-t border-zinc-800/60 py-20 lg:py-28"
  >
    <div
      aria-hidden="true"
      className="absolute left-0 top-24 h-72 w-72 rounded-full bg-amber-500/[0.06] blur-[110px]"
    />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="eyebrow" data-testid="shop-eyebrow">
          Storefronts
        </p>
        <h2
          data-testid="shop-heading"
          className="mt-3 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl"
        >
          Shop Sandstorm
        </h2>
        <p className="mt-4 max-w-2xl leading-relaxed text-zinc-400">
          Our inventory is listed across several established marketplaces, so you can
          shop on the platform you already trust. Every link below opens an official
          Sandstorm Trading storefront in a new tab.
        </p>
      </Reveal>
      <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {STORES.map((s, i) => (
          <StoreCard key={s.id} store={s} delay={i * 0.06} />
        ))}
      </div>
    </div>
  </section>
);
